export const EXPIRED_GUIDE_MODE = {
  NONE: 'none',
  GRACE: 'grace',
  SEVERE: 'severe'
}

/** 全部设备过期超 30 天且无有效未绑单时的独立续费页（禁止进设备 dashboard） */
export const EXPIRED_PURCHASE_PATH = '/expired-purchase'

/**
 * 不展示宽限期引导的路径。
 * dashboard 三个页面不在此列：过期后进后台也要提示，只是那里的弹窗可关闭（见 EXPIRED_GUIDE_DASHBOARD_PATHS）。
 */
export const EXPIRED_GUIDE_DETAIL_EXCLUDED_PATHS = [
  '/',
  '/pages/account-settings/account',
  '/android/local/permission-check',
  '/setup',
  '/ios/setup',
  '/ios/extreme-verification',
  '/android/setup',
  '/android/nodevice-setup',
  '/android/classification',
  '/android/local/setup',
  '/guide',
  '/referral-program',
  '/settings',
  '/suggestion-box',
  '/expired-purchase'
]

/** 全屏严重过期引导也不展示的路径（引导/设置流程） */
export const EXPIRED_GUIDE_SEVERE_EXCLUDED_PATHS = [
  '/setup',
  '/ios/setup',
  '/ios/extreme-verification',
  '/android/setup',
  '/android/nodevice-setup',
  '/android/classification',
  '/android/local/setup',
  '/guide',
  '/referral-program',
  '/settings',
  '/suggestion-box'
]

/**
 * 全员 lapsed 时仍允许停留的路径（勿强制踢去 /expired-purchase）。
 * 兼容 window.location.pathname（/guide/xxx）与 router.pathname（/guide/[slug]）。
 */
export const isExpiredPurchaseRedirectExcludedPath = pathname => {
  if (!pathname) return false

  const path = String(pathname).split('?')[0].replace(/\/$/, '') || '/'

  return EXPIRED_GUIDE_SEVERE_EXCLUDED_PATHS.some(excluded => {
    if (path === excluded) return true

    return path.startsWith(`${excluded}/`)
  })
}

export const EXPIRED_GUIDE_DASHBOARD_PATHS = ['/dashboard', '/android/dashboard', '/android/local/dashboard']

export const resolveDashboardPathByMode = mode => {
  if (mode === 'Android-Cloud') return '/android/dashboard'
  if (mode === 'Android-Local') return '/android/local/dashboard'

  return '/dashboard'
}
